import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const imageApi = createApi({
  reducerPath: 'imageApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({    
    imageMetaData: builder.query<any, { clientId: string, projectId: string, boreholeId: string, imageTypes: number[] }>({
      query: (arg: any) => { 
        const { clientId, projectId, boreholeId, imageTypes } = arg;
        const imageTypesQueryString = imageTypes.reduce((previousValue: any, currentValue: any) => { return previousValue + "imageTypes=" + currentValue + "&" }, "");
        return `client/${clientId}/project/${projectId}/borehole/${boreholeId}/image/MetaData?${imageTypesQueryString}`},
    })
  }),  
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useImageMetaDataQuery } = imageApi;